import { ComboBox, DefaultButton, IComboBoxOption, PrimaryButton, TextField } from "@fluentui/react";
import { Column, Grid, Row, isNullOrEmpty } from '@ioip/core/lib';
import React from 'react';
import { AuthenticationState, AzureAD, IAzureADFunctionProps, LoginType, MsalAuthProvider } from "react-aad-msal";
import { Sede } from '../../classes/shared';
import { ISignInResponse } from '../../classes/sign-in-response';
import { validateObject, validator } from '../../ioip/sdk/base';
import { basicReduxStore } from "../../reduxStore";
import { PqrWebService } from '../../services/services';
import { ISignInComponentProps } from './sign-in.props';
import { ISignInComponentState } from './sign-in.state';

export class SignInComponent extends React.Component<ISignInComponentProps, ISignInComponentState> {

  private _pqrWebService: PqrWebService;
  private _authProvider: MsalAuthProvider;

  private _validations: { [ key: string ]: any[] } = {
    IdTipoIdentificacion: [ validator.invalid(0, 'Campo requerido') ],
    Identificacion: [ validator.required(true), validator.maxLength(128) ],
    Password: [ validator.required(true), validator.maxLength(128) ]
  };

  constructor(props: any) {
    super(props);
    this.state = {
      errors: {},
      model: {
        IdTipoIdentificacion: 0,
        Identificacion: '',
        Password: '',
        Dominio: (window as any).domain
      },
      tiposIdentificacion: [],
      redirectConsultRequest: {
        show: false,
        fecha: null,
        url: ''
      },
      leyHabeasData: {
        texto: '',
        url: ''
      }
    };

    this._authProvider = new MsalAuthProvider(
      {
        auth: {
          authority: Sede.Shared.Context.B2C.Authority,
          clientId: Sede.Shared.Context.B2C.ClientId,
          postLogoutRedirectUri: window.location.origin + '/sede.html',
          redirectUri: window.location.origin + '/sede.html',
          validateAuthority: false,
        },
        cache: {
          cacheLocation: "localStorage",
          storeAuthStateInCookie: true
        }
      },
      {
        scopes: [ Sede.Shared.Context.B2C.Scopes ]
      },
      {
        loginType: LoginType.Popup,
        tokenRefreshUri: window.location.origin
      }
    );

    this._pqrWebService = new PqrWebService();
    this._loadDataAsync();
  }

  private get isAuthenticate(): boolean {
    const token = sessionStorage.getItem('ioip.pqr-web.session.token');
    if (token === null || token === undefined) {
      return false;
    }
    return true;
  }

  public async componentDidMount(): Promise<void> {
    try {
      if (this.isAuthenticate) {
        if (window.location.href.includes('?tramiteId=')) {
          window.location.href = this.props.ulrForm + '?tramiteId=' + window.location.href.split('?tramiteId=')[ 1 ];
        } else {
          window.location.href = this.props.ulrForm;
        }
      }
      let redirectConsultRequest = sessionStorage[ 'redirectConsultRequest_show' ];
      if (redirectConsultRequest == null) {
        const parameter = Sede.Shared.Context.FechaConsultaSolicitudes;
        if (!isNullOrEmpty(parameter) && parameter !== '-') {
          const fecha: string = parameter.split(',', 2)[ 0 ];
          const url: string = parameter.split(',', 2)[ 1 ];
          sessionStorage[ 'redirectConsultRequest_fecha' ] = fecha;
          sessionStorage[ 'redirectConsultRequest_url' ] = url;
          sessionStorage[ 'redirectConsultRequest_show' ] = true;
        }
        else {
          sessionStorage[ 'redirectConsultRequest_fecha' ] = '';
          sessionStorage[ 'redirectConsultRequest_url' ] = '';
          sessionStorage[ 'redirectConsultRequest_show' ] = false;
        }
      }

      let texto = '';
      let url = '';
      if (!isNullOrEmpty(Sede.Shared.Context.LeyHabeasData)) {
        texto = Sede.Shared.Context.LeyHabeasData.split('|', 2)[ 0 ];
        url = Sede.Shared.Context.LeyHabeasData.split('|', 2)[ 1 ];
      }

      this.setState({
        leyHabeasData: { texto: texto, url: url },
        redirectConsultRequest: {
          fecha: sessionStorage[ 'redirectConsultRequest_fecha' ],
          url: sessionStorage[ 'redirectConsultRequest_url' ],
          show: sessionStorage[ 'redirectConsultRequest_show' ] == 'true'
        }
      });

    } catch (error) {
      if (error instanceof Error) {
        alert(error.message);
      }
      console.log(error);
    }
  }

  render(): JSX.Element {

    return <Grid>
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm12'>
          <h1 className="ms-font-xl ms-fontWeight-semibold" >Identificación</h1>
        </div>
      </div>
      <Row>
        <Column size={6}>
          <ComboBox
            label='Tipo de identificación'
            selectedKey={this.state.model.IdTipoIdentificacion}
            onChange={(_, value) => this._onChangeComboBox('IdTipoIdentificacion', value)}
            options={this.state.tiposIdentificacion}
            useComboBoxAsMenuWidth={true}
            errorMessage={this.state.errors[ 'IdTipoIdentificacion' ]}
            required={true}
          />
        </Column>
        <Column size={6}>
          <TextField
            placeholder='Identificación'
            label='Identificación'
            maxLength={128}
            required={true}
            onChange={(_, value) => this._onChangeTextField('Identificacion', value)}
            errorMessage={this.state.errors[ 'Identificacion' ]}
            value={this.state.model.Identificacion}
          />
        </Column>
      </Row>
      <Row>
        <Column size={6}>
          <TextField
            placeholder='Contraseña'
            label='Contraseña'
            maxLength={16}
            required={true}
            type='password'
            onChange={(_, value) => this._onChangeTextField('Password', value)}
            errorMessage={this.state.errors[ 'Password' ]}
            value={this.state.model.Password}
          />
        </Column>
      </Row>
      <div className='ms-Grid-row'>
        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ paddingTop: '8px' }}>
          <small style={{ color: 'red' }}> {this.state.errors[ 'error' ]}</small>
        </div>
      </div>
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm12' style={{ marginTop: '15px', textAlign: 'right' }}>
          {
            Sede.Shared.Context.B2C.IsEnabled &&
            <AzureAD provider={this._authProvider} reduxStore={basicReduxStore}>
              {({ accountInfo, authenticationState, error }: IAzureADFunctionProps) => {
                return (
                  <>
                    {(
                      <AzureAD provider={this._authProvider} reduxStore={basicReduxStore} forceLogin={(sessionStorage[ 'forceLogin' ] == "true")} >
                        {({ login, logout, authenticationState }: IAzureADFunctionProps) => {
                          const isInProgress = authenticationState === AuthenticationState.InProgress;
                          const isAuthenticated = authenticationState === AuthenticationState.Authenticated;
                          const isUnauthenticated = authenticationState === AuthenticationState.Unauthenticated;
                          if (isUnauthenticated || isInProgress) {
                            return (
                              <PrimaryButton
                                className="Button"
                                onClick={login}
                                disabled={isInProgress}
                                text='Login B2C'
                              />
                            );
                          }
                          else {
                            if (isAuthenticated) {
                              sessionStorage.setItem('ioip.pqr-web.session.token', accountInfo.jwtIdToken);

                              const response = this._validarUsuario(accountInfo.jwtIdToken);

                              response.then(value => {
                                if (!value) {
                                  alert('Imposible autenticar el usuario');
                                  sessionStorage.clear();
                                  logout();
                                }
                              });

                              return (<div></div>);
                            }
                          }
                        }}
                      </AzureAD>
                    )}
                  </>
                );
              }}
            </AzureAD>
          }<span>&nbsp;&nbsp;</span>
          <PrimaryButton
            text='Continuar'
            onClick={this._signInAsync.bind(this)}
          />
          <span>&nbsp;&nbsp;</span>
          <DefaultButton
            text='Volver a inicio'
            href='#/home'
          />
        </div>
      </div>
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm12' style={{ marginTop: '15px' }}>
          <PrimaryButton
            text='Registrarme'
            onClick={() => window.location.href = '#/create-contact'}
          />
        </div>
      </div>
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm12' style={{ marginTop: '15px' }}>
          <a className="link" href='#/recover-password'>Olvidé mi contraseña</a>
        </div>
      </div>
      <br />
      <br />
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-u-sm12 block'>
          {this.state.leyHabeasData.texto}
          <a className="link" href={this.state.leyHabeasData.url} target='_blank'>{this.state.leyHabeasData.url}</a>
        </div>
      </div>
      {/*Texto para la consulta de solicitudes que no estén en la base de datos de ioip pero sí en un sistema anterior*/}
      {this.state.redirectConsultRequest.show &&
        <div>
          <div className='ms-Grid-row'>
            <div className="ms-Grid-col ms-u-sm12 block">
              Si requiere consultar una solicitud anterior a la fecha {this.state.redirectConsultRequest.fecha}, por favor de <a href={this.state.redirectConsultRequest.url}>clic aquí</a>.
            </div>
          </div>
        </div>
      }
    </Grid>
  }

  private async _loadDataAsync(): Promise<void> {
    try {
      let result = await this._pqrWebService.getAllIdentificationTypesAsync();
      this.setState({
        tiposIdentificacion: result.map(o => ({ key: o.IdTipoIdentificacion, text: o.Nombre })),
        model: {
          ...this.state.model,
          IdTipoIdentificacion: result && result.length > 0 ? result[ 0 ].IdTipoIdentificacion : 0
        }
      });
    } catch (ex) {
      alert('Se ha producido un error al obtener los tipos de identificación');
    }
  }

  private async _validarUsuario(token: string): Promise<boolean> {
    try {
      if (sessionStorage.getItem('ioip.pqr-web.session.autenticacion') != "true") {
        sessionStorage.setItem('ioip.pqr-web.session.token', token);
        sessionStorage.setItem('ioip.pqr-web.session.autenticacion', "true");
        var response: ISignInResponse = await this._pqrWebService.getDataUserAsync();

        if (response.IdContacto > 0) {
          await this._sesion(response);
          window.location.href = this.props.ulrForm;
          return true;
        }
        else
          if (response.IdContacto == -1 && sessionStorage[ 'b2c' ] != "true") {
            response = await this._pqrWebService.createDataUserAsync();
            await this._sesion(response);
            window.location.href = this.props.ulrForm;
            return true;
          }

        return false;
      }

      return true;
    }
    catch (ex) {
      sessionStorage.clear();
      return false;
    }
  }

  private _onChangeComboBox(property: string, option?: IComboBoxOption, index?: number, value?: string, submitPendingValueEvent?: any): void {
    const state = {
      model: {
        ...this.state.model,
        [ property ]: Number(option.key)
      }
    };
    this.setState(state);
  }

  private _onChangeTextField(property: string, value: string): void {
    const state = {
      model: {
        ...this.state.model,
        [ property ]: value
      }
    };
    this.setState(state);
  }

  private _updateErrors(errors: { [ key: string ]: string }): void {
    this.setState({ errors });
  }

  private async _signInAsync(): Promise<void> {
    if (validateObject(this.state.model, this._validations, this._updateErrors.bind(this))) {
      try {
        const response: ISignInResponse = await this._pqrWebService.sigInAsync(this.state.model);

        if (response) {
          if (!response.CorreoVerificado) {
            var resendUrl: boolean = window.confirm("Este usuario no está verificado, ¿desea reenviar el link de verificación de cuenta al correo registrado?");
            if (resendUrl) {
              await this._pqrWebService.resendAccountVerificationUrlAsync(response.IdContacto);
              alert(`Se ha enviado a su dirección de correo registrado un enlace, por favor ingresar para activar la cuenta`);
              window.location.href = '#/home';
            }
          }
          else {
            await this._sesion(response);
            window.location.href = this.props.ulrForm;
          }
        }
        else {
          alert("El usuario no existe o no ha activado su cuenta.");
        }
      } catch (ex) {
        this.setState({
          errors: {
            'error': 'Ocurrió un error al iniciar sesión, por favor verifique que sus datos sean correctos.'
          }
        })
      }
    }
  }

  private async _sesion(response: ISignInResponse) {
    sessionStorage.setItem('ioip.pqr-web.session.idcontacto', response.IdContacto.toString());
    sessionStorage.setItem('ioip.pqr-web.session.idtipocontacto', response.IdTipoContacto.toString());
    sessionStorage.setItem('ioip.pqr-web.session.nombres', response.Nombres);
    sessionStorage.setItem('ioip.pqr-web.session.apellidos', response.Apellidos);
    sessionStorage.setItem('ioip.pqr-web.session.tipoid', response.TipoId.toString());
    sessionStorage.setItem('ioip.pqr-web.session.identificacion', response.Identificacion);
    sessionStorage.setItem('ioip.pqr-web.session.email', response.Email);
    sessionStorage.setItem('ioip.pqr-web.session.celular', response.Celular);
    sessionStorage.setItem('ioip.pqr-web.session.telefono', response.Telefono);
    sessionStorage.setItem('ioip.pqr-web.session.direccion', response.Direccion);
    sessionStorage.setItem('ioip.pqr-web.session.barrio', response.Barrio);
    sessionStorage.setItem('ioip.pqr-web.session.extension', response.Extension);
    sessionStorage.setItem('ioip.pqr-web.session.idpais', response.IdPais.toString());
    sessionStorage.setItem('ioip.pqr-web.session.iddepartamento', response.IdDepartamento.toString());
    sessionStorage.setItem('ioip.pqr-web.session.idciudad', response.IdCiudad.toString());
    sessionStorage.setItem('ioip.pqr-web.session.codigopostal', response.CodigoPostal);
    sessionStorage.setItem('ioip.pqr-web.session.token', response.Token);
    sessionStorage.setItem('ioip.pqr-web.session.expiracion', response.FechaExpiracion);
    sessionStorage.setItem('ioip.pqr-web.session.idantencionpreferencial', response.IdAntencionPreferencial.toString());
    sessionStorage.setItem('ioip.pqr-web.session.iddiscapacidad', response.IdDiscapacidad.toString());
    sessionStorage.setItem('ioip.pqr-web.session.idgenero', response.IdGenero.toString());
    sessionStorage.setItem('ioip.pqr-web.session.idgrupoetnico', response.IdGrupoEtnico.toString());

    sessionStorage.setItem('ioip.pqr-web.session.nombrerepresentante', response.NombreRepresentante.toString());
    sessionStorage.setItem('ioip.pqr-web.session.emailrepresentante', response.EmailRepresentante.toString());
    sessionStorage.setItem('ioip.pqr-web.session.cargorepresentante', response.CargoRepresentante.toString());
    sessionStorage.setItem('ioip.pqr-web.session.telefonorepresentante', response.TelefonoRepresentante.toString());
    sessionStorage.setItem('ioip.pqr-web.session.idtipopersona', response.IdTipoPersona.toString());

    sessionStorage.setItem('ioip.pqr-web.session.primernombre', response.PrimerNombre.toString());
    sessionStorage.setItem('ioip.pqr-web.session.segundonombre', response.SegundoNombre.toString());
    sessionStorage.setItem('ioip.pqr-web.session.primerapellido', response.PrimerApellido.toString());
    sessionStorage.setItem('ioip.pqr-web.session.segundoapellido', response.SegundoApellido.toString());

    sessionStorage.setItem('ioip.pqr-web.session.fechaModificacion', response.FechaModificacion.toString());

    sessionStorage.setItem('ioip.pqr-web.session.idprofesion', response.IdProfesion.toString());
    sessionStorage.setItem('ioip.pqr-web.session.idnivelEducativo', response.IdNivelEducativo.toString());

    sessionStorage.setItem('ioip.pqr-web.session.fechaNacimiento', response.FechaNacimientoString.toString());

    sessionStorage.setItem('ioip.pqr-web.session.idtipoentidad', response.IdTipoEntidad.toString());

    sessionStorage.setItem('ioip.pqr-web.session.autorizatratamientodatos', response.AutorizaTratamientoDatos.toString());
    sessionStorage.setItem('ioip.pqr-web.session.autorizallamadacelular', response.AutorizaLlamadaCelular.toString());
    sessionStorage.setItem('ioip.pqr-web.session.autorizallamadafijo', response.AutorizaLlamadaFijo.toString());
    sessionStorage.setItem('ioip.pqr-web.session.autorizanotificacionemail', response.AutorizaNotificacionEmail.toString());
    sessionStorage.setItem('ioip.pqr-web.session.autorizanotificacionfisica', response.AutorizaNotificacionFisica.toString());
    sessionStorage.setItem('ioip.pqr-web.session.actuacomoapoderado', response.ActuaComoApoderado.toString());
    sessionStorage.setItem('ioip.pqr-web.session.idtipoidentificacionapoderado', response.IdTipoIdentificacionApoderado.toString());
    sessionStorage.setItem('ioip.pqr-web.session.identificacionapoderado', response.IdentificacionApoderado.toString());
    sessionStorage.setItem('ioip.pqr-web.session.nombresapoderado', response.NombresApoderado.toString());
    sessionStorage.setItem('ioip.pqr-web.session.apellidosapoderado', response.ApellidosApoderado.toString());
    sessionStorage.setItem('ioip.pqr-web.session.telefonoapoderado', response.TelefonoApoderado.toString());
    sessionStorage.setItem('ioip.pqr-web.session.direccionapoderado', response.DireccionApoderado.toString());
    sessionStorage.setItem('ioip.pqr-web.session.emailapoderado', response.EmailApoderado.toString());
  }
}